// Components==============
import { faGripLinesVertical } from '@fortawesome/pro-regular-svg-icons';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import './TrainingContentCard.module.scss';

// =========================

export default function TrainingContentCard({
  id,
  index,
  children,
  handleRemove,
}: {
  id: number;
  index: number;
  children: React.ReactNode;
  handleRemove: () => void;
}) {
  return (
    <Draggable key={id} draggableId={id.toString()} index={index}>
      {(dragProvided) => (
        <div
          styleName="wrapper"
          ref={dragProvided.innerRef}
          {...dragProvided.draggableProps}
        >
          <div styleName="handler" {...dragProvided.dragHandleProps}>
            <FontAwesomeIcon icon={faGripLinesVertical} />
          </div>
          <div>{children}</div>
          <div styleName="trash">
            <CircleButton icon={faTrash} onClick={handleRemove} color="white" />
          </div>
        </div>
      )}
    </Draggable>
  );
}
